import { Button, Icon, useDisclosure } from "@chakra-ui/react";
import { ElementType } from "react";
import { Link } from "react-router-dom";
import { ModalContentBranchPath } from "../../molecules/Modal/ModalContentBranchPath";

interface ModalBranchPathProps {
  label: string;
  title: string;
  text: string;
  icon?: ElementType;
  firstOptionLink: string;
  secondOptionLink: string;
  firstOptionName: string;
  secondOptionName: string;
}

export function ModalBranchPath({
  label,
  text,
  title,
  icon,
  firstOptionLink,
  secondOptionLink,
  firstOptionName,
  secondOptionName,
}: ModalBranchPathProps) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  return (
    <>
      <Button
        bg="#216ca5"
        _hover={{
          background: "#216ca5",
          opacity: 0.8,
        }}
        _active={{
          background: "#216ca5",
          opacity: 0.8,
        }}
        color="#fff"
        onClick={onOpen}
      >
        {icon && <Icon as={icon} mr="2" />} {label}
      </Button>
      <ModalContentBranchPath
        text={text}
        title={title}
        onClose={onClose}
        isOpen={isOpen}
      >
        <Link to={firstOptionLink}>
          <Button
            bg="#216ca5"
            _hover={{
              background: "#216ca5",
              opacity: 0.8,
            }}
            _active={{
              background: "#216ca5",
              opacity: 0.8,
            }}
            color="#fff"
          >
            {firstOptionName}
          </Button>
        </Link>
        <Link to={secondOptionLink}>
          <Button
            bg="#fd9000"
            _hover={{
              background: "#fd9000",
              opacity: 0.8,
            }}
            _active={{
              background: "#fd9000",
              opacity: 0.8,
            }}
            color="#fff"
            ml="2"
          >
            {secondOptionName}
          </Button>
        </Link>
      </ModalContentBranchPath>
    </>
  );
}
